export default function SubscribersTable({ subscribers }) {
  return (
    <div>
      <h3 className="font-['Cormorant_Garamond'] text-2xl text-[#fdfbf7] mb-6">Newsletter Subscribers</h3>
      <div className="w-full overflow-x-auto rounded-lg border border-[#1c2a3d]">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr>
              <th className="bg-[#1c2a3d] text-[#a3b1c6] font-medium p-4 border-b border-[#1c2a3d] text-sm">Email</th>
              <th className="bg-[#1c2a3d] text-[#a3b1c6] font-medium p-4 border-b border-[#1c2a3d] text-sm">Subscribed At</th>
            </tr>
          </thead>
          <tbody>
            {subscribers.length === 0 ? (
              <tr><td colSpan={2} className="p-8 text-center text-[#a3b1c6]">No subscribers yet</td></tr>
            ) : (
              subscribers.map(s => (
                <tr key={s.id} className="hover:bg-[#1c2a3d]/50 transition-colors">
                  <td className="p-4 border-b border-[#1c2a3d] text-[#fdfbf7] text-sm">{s.email}</td>
                  <td className="p-4 border-b border-[#1c2a3d] text-[#a3b1c6] text-sm">{s.subscribed_at}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
